module.exports = __webpack_public_path__ + "static/img/temp-4.67330bd6.jpg";